import { GridModel } from "common/models/utility-models/list-utility.model";
import { DocumentReportsModel } from "./document-report-data-model";

export class DocumentReportsGridModel extends DocumentReportsModel { }

export class DocumentReportsListingModel extends GridModel<DocumentReportsModel> {
  filterData: any;
}